// ------------------------------------------------------------------
// 新TOPページ：メルマガ登録ポップアップ
// ボタンで <dialog> を開く。送信後（完了・エラー）の再読み込み時は自動で開く。
// ------------------------------------------------------------------
if (!customElements.get('ntop-newsletter')) {
  class NtopNewsletter extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-newsletter-modal]');
      if (!this.modal || typeof this.modal.showModal !== 'function') return;

      this.querySelector('[data-newsletter-open]')?.addEventListener('click', () => this.open());
      // バナーのどこを押してもポップアップを開く（ボタン自体のクリックは上で処理済み）
      this.querySelector('[data-newsletter-banner]')?.addEventListener('click', (e) => {
        if (e.target.closest('[data-newsletter-open]')) return;
        this.open();
      });
      this.modal.querySelectorAll('[data-newsletter-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.modal.close());
      });
      // パネルの外（背景）をクリックしたら閉じる
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.modal.close();
      });
      this.modal.addEventListener('close', () => {
        document.documentElement.classList.remove('ntop-modal-open');
      });

      if (this.modal.hasAttribute('data-open-on-load')) {
        this.open();
        this.clearPostedState();
      }
    }

    // 送信後の URL（?customer_posted=true#フォームID）をそのままにすると、
    // 再読み込みのたびに完了メッセージのポップアップが開いてしまうので、表示後に取り除く
    clearPostedState() {
      if (!window.history?.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      if (url.hash && this.modal.closest('form')?.id === url.hash.slice(1)) url.hash = '';
      window.history.replaceState(window.history.state, '', url.toString());
    }

    open() {
      if (this.modal.open) return;
      this.modal.showModal();
      document.documentElement.classList.add('ntop-modal-open');
      const input = this.modal.querySelector('input[type="email"]');
      if (input) input.focus();
    }
  }

  customElements.define('ntop-newsletter', NtopNewsletter);
}
